import React, {FunctionComponent} from 'react';
import {_ReactPixi, Container} from '@inlet/react-pixi';
import {DotButton} from '@gongxigames/framework/slot/modules/loadingScreen/components/Slides/DotButton';

const DOT_OFFSET = 94 + 32;

export type DotButtonsProps = Omit<_ReactPixi.IContainer, 'position' | 'scale'> & {
    slides: number;
    activeIndex: number;
    setIndex: (i: number) => void;
    dotsPosition?: [number, number];
};

export const DotButtons: FunctionComponent<DotButtonsProps> = ({setIndex, dotsPosition, slides, activeIndex}) => {
    const dotsOffset = -Math.max(slides - 1, 0) * DOT_OFFSET / 2;
    const x = (dotsPosition?.[0] || 0) + dotsOffset;
    const y = (dotsPosition?.[1] || 0);
    const dots = [];

    for (let i = 0; i < slides; i++) {
        const isActive = i === activeIndex;
        const offset = i * DOT_OFFSET;

        dots.push(<DotButton key={i} active={isActive} press={() => setIndex(i)} position={[offset, 0]}/>);
    }

    return <Container name='dots' position={[x, y]}>{dots}</Container>;
};
